module.exports = __webpack_public_path__ + "static/img/A18.ea4c4618.jpg";